import { PrismicRichText } from '@prismicio/react';
import { Link } from 'react-router-dom';
import { ChangeEvent, useState, useCallback } from 'react';

import { ContentProps } from '../termsOfUse/types';
import { Button, Checkbox } from '../../../component';
import { IcoToExternalPage } from '../icon/toExternaPageIcon';

interface TermsOfUseProps {
  cy?: string;
  content: ContentProps | null;
  onAcceptButtonClick: () => void;
  onDeclineButtonClick: () => void;
  isModal?: boolean;
}

function TermsOfUse({
  cy = 'TermsOfUse',
  content,
  onAcceptButtonClick,
  onDeclineButtonClick,
  isModal = true,
}: TermsOfUseProps) {
  const [agreeTerms, setAgreeTerms] = useState<boolean>(false);

  const onCheckBoxChange = useCallback(() => {
    setAgreeTerms((prevState) => !prevState);
  }, []);

  return (
    <div id="root-terms-of-use">
      <div className={`terms-of-use ${isModal ? 'modal' : 'page'}`}>
        <div className="terms-of-use-content">
          <h1>{content ? content.title : null}</h1>
          <PrismicRichText
            field={content?.data}
            fallback={<p>Houve um problema ao carregar o conteúdo.</p>}
          />
        </div>
        <Checkbox
          cy={`${cy}AgreeCheckbox`}
          name="terms-of-use-checkbox"
          checked={!!agreeTerms}
          action={onCheckBoxChange}
          label="Li, entendi e estou de acordo com os Termos de Uso."
        />
        <div className="terms-of-use-buttons-container">
          <div className="left-buttons">
            <Link to={'/terms-of-use'} target="_blank" rel="noreferrer">
              <span className="icon">
                <IcoToExternalPage cy="TermsOfUse" />
              </span>
              <span>Abrir em nova guia</span>
            </Link>
          </div>
          <div className="right-buttons">
            <Button
              cy="TermsOfUseDeclineButton"
              color="primary"
              size="block"
              variant="outline"
              onClick={onDeclineButtonClick}
            >
              Recusar
            </Button>
            <Button
              cy="TermsOfUseAcceptButton"
              color="primary"
              size="block"
              onClick={onAcceptButtonClick}
              disabled={!agreeTerms}
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
